import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { AuthLayout } from "@/components/AuthLayout";
import { Field, BigButton } from "@/components/Field";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function ForcePassword() {
  const { user, setUser, logout } = useAuth();
  const [pw, setPw] = useState({ a: "", b: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return toast.error("As senhas não conferem");
    try {
      await api.post("/auth/change-password", { new_password: pw.a });
      setUser({ ...user, must_change_password: false });
      toast.success("Senha criada! Bem-vindo(a).");
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <AuthLayout title="Crie sua senha" subtitle={`Olá, ${user.name}! Este é seu primeiro acesso. Crie uma senha pessoal para continuar.`}>
      <form onSubmit={submit} className="space-y-5" data-testid="force-password-form">
        <Field label="Nova senha (mín. 6 caracteres)" id="fp1" type="password" minLength={6} required value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} data-testid="force-password-input" />
        <Field label="Confirmar nova senha" id="fp2" type="password" minLength={6} required value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} data-testid="force-password-confirm" />
        <BigButton type="submit" data-testid="force-password-submit"><KeyRound className="h-5 w-5" /> Salvar e entrar</BigButton>
        <button type="button" onClick={logout} className="w-full h-12 text-[#5C6B66] font-semibold" data-testid="force-password-logout">Sair</button>
      </form>
    </AuthLayout>
  );
}
